import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const FinancialAccountsTransactionsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "FinancialAccountsTransactions" */
      '../../../components/MoneyManagement/FinancialAccountsTransactions'
    ),
  releaseState: 'internal',
  enabledKey: 'internal',
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays a list of transactions for all financial accounts.',
  friendlyName: 'Financial accounts transactions',
  enableV2APIToken: true,
};
